import React from 'react';
import { connect } from 'react-redux';
// import { getTodayEventWrapper } from '@/component/calendar/CalendarWrapper.js';
import { hideTodaysEvent } from '@/component/calendar/calendar.store.js';
import {
  Col,
  Row,
  Glyphicon,
} from 'react-bootstrap';
import {
  Button,
} from '../../../form/FormControls.jsx';
import { getFontColorFromBackground } from '@/util/util.jsx';
import AvailableSince, { VERSIONS } from '@/util/version';


class EventsClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: <div></div> };
  }
  componentWillMount() {
  //  getTodayEventWrapper();
    if (this.props.data) {
      this.setState({ data: this.createDataToDisplay(this.props) });
    }
  }
  componentWillReceiveProps(props) {
  //  getTodayEventWrapper();
    if (props.data) {
      this.setState({ data: this.createDataToDisplay(props) });
    }
  }
  createDataToDisplay(props) {
    const events = [];
    props.data.forEach((event, idx) => {
      if (!(props.hidden && props.hidden.has(event.get('id')))) {
        const textColor = getFontColorFromBackground(event.get('color'));
        events.push(<Row
          key={idx} style={{ margin: '5px 15px', border: 'thin solid lightgray',
            background: event.get('color'), padding: '3px 0px' }}
        >
          <Col sm={12}>
            <Col
              sm={11} style={{ color: textColor,
                float: 'left', wordBreak: 'break-all' }}
            >
              {event.get('startDate')} - {event.get('fullDescription')}
            </Col>
            <Col sm={1}>
              <Button
                bsStyle="link" className="link" style={{ padding: 0 }}
                onClick={() => props.hideEvent(event.get('id'))}
              >
                <Glyphicon
                  style={{ float: 'right', color: textColor,
                    border: `2px solid ${textColor}`, borderRadius: '20px',
                    padding: '2px',	cursor: 'pointer' }} glyph="remove"
                />
              </Button>
            </Col>
          </Col>
        </Row>
        );
      }
    });
    return <div>{events}</div>;
  }

  render() {
    return <AvailableSince version={VERSIONS.Sometime}>{this.state.data}</AvailableSince>;
  }
}
EventsClass.propTypes = {
  data: React.PropTypes.object,
  hidden: React.PropTypes.object,
  hideEvent: React.PropTypes.func,
};

export default connect(
  (store) => ({
    data: store.getIn(['data', 'events', 'today']),
    hidden: store.getIn(['data', 'events', 'otherdata', 'hidden']),
  }),
  (dispatch) => ({
    hideEvent(id) { hideTodaysEvent(dispatch, id); },
  })
)(EventsClass);
